import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import isEqual from 'lodash/isEqual'
import { FulfilmentType } from '../../../models/fulfilment'
import {
  selectLineItems,
  selectUnknownLineItems,
} from '../../../state/slices/currentSale/currentSaleSlice'

type FulfillmentSection = 'TAKENOW' | 'DISPATCH' | 'PICKUP'

export const useShowSection = (sectionType: FulfillmentSection) => {
  const lineItems = useSelector(selectLineItems, isEqual)
  const unknownLineItems = useSelector(selectUnknownLineItems, isEqual)

  const {
    hasDeliveryOrPickupItems,
    hasUnspecifiedOrUndefinedFulfilment,
    hasDeliveryItems,
    hasPickupItems,
  } = useMemo(() => {
    return [...lineItems, ...unknownLineItems].reduce(
      (acc, item) => {
        if ('fulfilmentType' in item) {
          if (item.fulfilmentType === FulfilmentType.DELIVERY) {
            acc.hasDeliveryItems = true
            acc.hasDeliveryOrPickupItems = true
          } else if (item.fulfilmentType === FulfilmentType.PICKUP) {
            acc.hasPickupItems = true
            acc.hasDeliveryOrPickupItems = true
          } else if (
            item.fulfilmentType === undefined ||
            item.fulfilmentType === FulfilmentType.UNSPECIFIED
          ) {
            acc.hasUnspecifiedOrUndefinedFulfilment = true
          }
        } else {
          acc.hasUnspecifiedOrUndefinedFulfilment = true
        }
        return acc
      },
      {
        hasDeliveryOrPickupItems: false,
        hasUnspecifiedOrUndefinedFulfilment: false,
        hasDeliveryItems: false,
        hasPickupItems: false,
      }
    )
  }, [lineItems, unknownLineItems])

  return useMemo(() => {
    switch (sectionType) {
      case 'TAKENOW':
        return hasDeliveryOrPickupItems && hasUnspecifiedOrUndefinedFulfilment
      case 'DISPATCH':
        return hasDeliveryItems
      case 'PICKUP':
        return hasPickupItems
      default:
        return false
    }
  }, [
    sectionType,
    hasDeliveryOrPickupItems,
    hasUnspecifiedOrUndefinedFulfilment,
    hasDeliveryItems,
    hasPickupItems,
  ])
}
